import confirmPair from '../locales/final-check-confirm.json'
import type { FinalCheckOrder } from '../types'

export type FinalCheckClass = 'one-click' | 'changed' | 'unreadable'

export type Recheck =
  | { kind: 'proceed' }
  | { kind: 'changed'; row: FinalCheckOrder }
  | { kind: 'gone' }

const TWO_DECIMAL = /^-?\d+\.\d{2}$/

function readableTotal(v: unknown): boolean {
  return typeof v === 'string' && TWO_DECIMAL.test(v) && Number.isFinite(Number(v))
}

// The row's money is read through here, never trusted: apiGet casts without validating.
export function classify(row: FinalCheckOrder): FinalCheckClass {
  if (
    typeof row.moneyChanged !== 'boolean' ||
    !readableTotal(row.totalNow) ||
    !readableTotal(row.totalAtPlacement) ||
    typeof row.currency !== 'string' ||
    row.currency === ''
  ) {
    return 'unreadable'
  }
  return row.moneyChanged ? 'changed' : 'one-click'
}

// Fills {name} by name, so a translation may place the slots in its own order.
export function fillSlots(text: string, slots: Record<string, string>): string {
  return text.replace(/\{(\w+)\}/g, (whole, name: string) => (name in slots ? slots[name] : whole))
}

// ux3 (f): the two filled lines of the ask, for the in-app dialog. null when nothing to ask.
export function confirmLines(row: FinalCheckOrder): { ar: string; en: string } | null {
  const kind = classify(row)
  if (kind === 'one-click') return null
  const pair = kind === 'changed' ? confirmPair.changed : confirmPair.unreadable
  const slots = {
    from: `${row.currency} ${row.totalAtPlacement}`,
    to: `${row.currency} ${row.totalNow}`,
  }
  return { ar: fillSlots(pair.ar, slots), en: fillSlots(pair.en, slots) }
}

// Arabic first with the English beside it, as one string.
export function confirmText(row: FinalCheckOrder): string {
  const lines = confirmLines(row)
  return lines ? `${lines.ar}\n\n${lines.en}` : ''
}

export function recheck(shownRow: FinalCheckOrder, freshRows: FinalCheckOrder[], id: string): Recheck {
  const fresh = freshRows.find((r) => r.id === id)
  if (!fresh) return { kind: 'gone' }
  if (
    fresh.moneyChanged !== shownRow.moneyChanged ||
    fresh.totalNow !== shownRow.totalNow ||
    fresh.totalAtPlacement !== shownRow.totalAtPlacement
  ) {
    return { kind: 'changed', row: fresh }
  }
  return { kind: 'proceed' }
}
